import reportErrorSentry from "src/lib/reportErrorSentry";

let heicToModule: typeof import("heic-to") | null = null;
let loadFailed = false;

// Dynamic import can throw if the LGPL chunk fails to fetch (offline, CDN
// error, end-user swapped in a broken replacement). Cache the failure so we
// don't spam network requests or Sentry on every subsequent call.
const loadHeicTo = async (): Promise<typeof import("heic-to") | null> => {
  if (loadFailed) {
    return null;
  }
  if (heicToModule) {
    return heicToModule;
  }
  try {
    heicToModule = await import("heic-to");
    return heicToModule;
  } catch (e) {
    loadFailed = true;
    reportErrorSentry(e);
    return null;
  }
};

export const isHeicFile = async (file: File): Promise<boolean> => {
  const mod = await loadHeicTo();
  if (!mod) {
    return false;
  }
  try {
    return await mod.isHeic(file);
  } catch {
    return false;
  }
};

export const convertHeicToJpeg = async (blob: Blob): Promise<Blob> => {
  const mod = await loadHeicTo();
  if (!mod) {
    throw new Error("heic-to module unavailable");
  }
  return mod.heicTo({
    blob,
    type: "image/jpeg",
    quality: 0.92
  });
};
